import React, { useCallback, useMemo, useState } from 'react';
import './SearchDesktop.css';
import classNames from 'classnames';
import { SearchInput } from '../../../../../../shared/src/components/Search/SearchInput';
import { PerfUtilService } from '../../../../../../shared/src/services/util/perf-util.service';
import { useGameSearch } from '../../../../../../shared/src/components/Search/hooks/use-game-search.hook';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslations } from '../../../../../../shared/src/hooks/use-translations.hook';
import { SearchResults } from '../../../../../../shared/src/components/Search/SearchResults/SearchResults';
import { LoadGameConfirmContext } from '../../../../../../shared/src/components/Search/contexts/load-game-confirm.context';
import { SessionEndConfirmPopup } from '../../../../../../shared/src/components/SessionEndConfirmPopup';
import { useActiveStateWithTimeoutHook } from '../../../../../../shared/src/hooks/use-active-state-with-timeout.hook';
import { useAsgActions } from '../../../../../../shared/src/hooks/use-asg-actions.hook';
import { useDeviceTypeHook } from '../../../../../../shared/src/hooks/use-device-type.hook';

export const SearchDesktop = () => {
    const dispatch = useDispatch();
    const {
        currentGame: {
            searchActive,
        },
    } = useSelector((state) => state.casino);
    const { fillCurrentGameSearchStatus } = useAsgActions();
    const { t } = useTranslations();
    const [searchQuery, setSearchQuery] = useState('');
    const [confirmPopupGame, setConfirmPopupGame] = useState(null);
    const { searchResult } = useGameSearch(searchQuery);
    const { isMobile } = useDeviceTypeHook();
    const {
        isActive: popupActive,
        deactivate: closePopup,
        activate: activatePopup,
    } = useActiveStateWithTimeoutHook({
        timeoutMs: 7_000,
    });

    const searchConfig = useMemo(() => ({
        openGameWithConfirm: true,
        activateConfirmPopup: (game) => {
            setConfirmPopupGame(game);
            activatePopup();
        },
    }), []);

    const onSearchQueryChange = useCallback(
        PerfUtilService.debounce((searchQueryUpdated) => {
            setSearchQuery(searchQueryUpdated);
        }, 300),
        [],
    );

    const showSearchResults = useCallback(() => {
        dispatch(fillCurrentGameSearchStatus(true));
    }, []);

    const hideSearchResults = useCallback((e) => {
        // prevent onClick on .game-page-header-search
        e.stopPropagation();
        dispatch(fillCurrentGameSearchStatus(false));
    }, []);

    const onGameChange = useCallback((e) => {
        closePopup();
        hideSearchResults(e);
    }, []);

    const wrapperClass = classNames(
        'game-page-header-search',
        {
            'game-page-header-search--desktop': !isMobile,
        }
    );

    return (
        <div
            className={wrapperClass}
            onClick={showSearchResults}
        >
            <SearchInput
                inputClassName="game-page-header-item-hoverable"
                placeholderText={t('searchGames')}
                onSearchQueryChange={onSearchQueryChange}
                showClearButton={false}
            />

            {searchActive && <>
                <LoadGameConfirmContext.Provider value={searchConfig}>
                    <SearchResults
                        searchResult={searchResult}
                        searchQuery={searchQuery}
                    />
                </LoadGameConfirmContext.Provider>
                <div
                    className="game-page-header-search-overlay"
                    onClick={hideSearchResults}
                />
            </>}

            {popupActive && confirmPopupGame && <>
                <SessionEndConfirmPopup
                    gameId={confirmPopupGame.id}
                    gameName={confirmPopupGame.name}
                    onConfirmClickHandler={onGameChange}
                />
                <div
                    className="game-page-header-search-overlay game-page-header-search-overlay--popup"
                    onClick={closePopup}
                />
            </>}
        </div>
    );
};
